import React from 'react';
import { Button, Stack, Typography, alpha, useTheme } from '@mui/material';
import { PrintOutlined } from '@mui/icons-material';

interface Props {
  selectedCount: number;
  /** Everyone matching the filters. */
  total: number;
  noun: { one: string; many: string };
  onClear: () => void;
  onPrintSelected: () => void;
  onPrintAll: () => void;
}

/** Above a list of people: what is ticked, and the print actions. */
const CardsToolbar: React.FC<Props> = ({ selectedCount, total, noun, onClear, onPrintSelected, onPrintAll }) => {
  const theme = useTheme();
  const selecting = selectedCount > 0;
  return (
    <Stack
      direction="row" alignItems="center" spacing={1.5}
      sx={{
        px: 2, py: 1.25, minHeight: 52, borderBottom: 1, borderColor: 'divider',
        bgcolor: selecting ? alpha(theme.palette.primary.main, 0.06) : 'transparent',
        transition: 'background-color .2s',
      }}
    >
      <Typography variant="body2" sx={{ flex: 1 }} color={selecting ? 'primary.main' : 'text.secondary'} fontWeight={selecting ? 600 : 400}>
        {selecting
          ? `${selectedCount} ${selectedCount === 1 ? noun.one : noun.many} selected`
          : `${total} ${total === 1 ? noun.one : noun.many} · tick some to print just theirs`}
      </Typography>
      {selecting ? (
        <>
          <Button size="small" onClick={onClear} sx={{ textTransform: 'none' }}>Clear</Button>
          <Button size="small" variant="contained" disableElevation startIcon={<PrintOutlined />} onClick={onPrintSelected} sx={{ textTransform: 'none' }}>
            Print {selectedCount} {selectedCount === 1 ? 'card' : 'cards'}
          </Button>
        </>
      ) : (
        <Button size="small" variant="contained" disableElevation startIcon={<PrintOutlined />} disabled={total === 0} onClick={onPrintAll} sx={{ textTransform: 'none' }}>
          Print all {total}
        </Button>
      )}
    </Stack>
  );
};

export default CardsToolbar;
